import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=a66878ac&scoped=true&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=a66878ac&prod&lang=scss&"
import style1 from "./CampaignDetails.vue?vue&type=style&index=1&id=a66878ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66878ac",
  null
  
)

export default component.exports